import React from 'react'
import "../Assets/css/loading.css"

export default function Loading() {
    return (
        <div className="loadingFullPageParent">
            <div className="loader"></div>
        </div>
    )
}
